// @ts-nocheck
/* eslint-enable */
import React from 'react';
import * as S from 'app/shared/modules/area/AreaFacts/styles';

const quickAnswers = {
  '1543325321': {
    url: 'https://hotpads.com/denver-co/apartments-for-rent',
    questions: [
      {
        question: (
          <S.FactHeader htmlTag="h2" size="lg">
            Why Move to Denver, CO?
          </S.FactHeader>
        ),
        answerType: 'answer',
        answer: (
          <>
            <S.FactParagraph size="sm" htmlTag="p">
              Thinking of moving to Denver, Colorado? Here's what you need to know before renting your Denver home.
            </S.FactParagraph>
            <S.FactParagraph size="sm" htmlTag="p">
              Denver, being the capital of Colorado, is also the gateway to the great Rocky Mountains. The “Mile High
              City” is located just 12 miles east of the Front Range, a mountain range of the Southern Rockies within
              Central Colorado, and as a result, Denver residents enjoy a short distance to world-class skiing, rock
              climbing, hiking and biking trails. Denverites have warmly welcomed visitors and new residents since its
              inception as a mining and supply town for the gold rush in the mid-19th century, and Denver has been
              growing steadily ever since. The city of Denver has a population of nearly 730,000 reported in 2020; the
              larger metro surrounding Denver (including cities of Aurora and Lakewood) reports a population of almost 3
              million people.
            </S.FactParagraph>
          </>
        ),
      },
      {
        question: (
          <S.FactHeader htmlTag="h2" size="lg">
            Who Lives in Denver?
          </S.FactHeader>
        ),
        answerType: 'answer',
        answer: (
          <>
            <S.FactParagraph size="sm" htmlTag="p">
              While growing families occupy the surrounding suburbs, the city of Denver is a diverse oasis for the
              youthful and unattached. The city population skews younger, with only 30% of residents over the age of 45
              and 60% of the population unmarried. The rate of home ownership is 49.6%; a pretty even split between
              homeowners and renters.
            </S.FactParagraph>
            <S.FactParagraph size="sm" htmlTag="p">
              Random fact: residents of Denver have a life expectancy of 80.02 years.
            </S.FactParagraph>
          </>
        ),
      },
      {
        question: (
          <S.FactHeader htmlTag="h2" size="lg">
            Who are the Denver, CO Local Politicians?
          </S.FactHeader>
        ),
        answerType: 'answer',
        answer: (
          <>
            <S.FactParagraph size="sm" htmlTag="p">
              When moving to a new area it’s always a good idea to familiarize yourself with the local politics and city
              council members. They represent the interests of their constituents, potentially you. Here’s some quick
              insight into the{' '}
              <a href="https://www.denvergov.org/content/denvergov/en/denver-city-council.html">Denver City Council</a>:
            </S.FactParagraph>
            <S.FactParagraph size="sm" htmlTag="p">
              Denver Mayor:{' '}
              <a href="https://en.wikipedia.org/wiki/Michael_Hancock_(Colorado_politician)">Michael Hancock</a> (D)
            </S.FactParagraph>
            <S.FactSubHeader htmlTag="h3" size="md">
              Denver City Council Members:
            </S.FactSubHeader>
            <S.FactParagraph size="sm" htmlTag="p">
              Use this <a href="https://www.denvergov.org/maps/map/councildistricts">Council Districts map</a> to find
              out which district you could potentially be living in and match with the council member below.
            </S.FactParagraph>
            <S.FactUnorderedList>
              <li>Council District 1 - Amanda P. Sandoval </li>
              <li>Council District 2 - Kevin Flynn</li>
              <li>Council District 3 - Jamie Torres</li>
              <li>Council District 4 - Kendra Black</li>
              <li>Council District 5 - Amanda Sawyer</li>
              <li>Council District 6 - Paul Kashmann</li>
              <li>Council District 7 - Jolon Clark, President</li>
              <li>Council District 8 - Christopher Herndon</li>
              <li>Council District 9 - Candi CdeBaca</li>
              <li>Council District 10 - Chris Hinds</li>
              <li>Council District 11 - Stacie Gilmore</li>
              <li>Council At-Large - Robin Kniech</li>
              <li>Council At-Large - Deborah 'Debbie' Ortega</li>
            </S.FactUnorderedList>
          </>
        ),
      },
      {
        question: (
          <S.FactHeader htmlTag="h2" size="lg">
            What’s an overview of the Denver, CO Economy?
          </S.FactHeader>
        ),
        answerType: 'answer',
        answer: (
          <>
            <S.FactParagraph size="sm" htmlTag="p">
              Young professionals thrive in Denver as the city has topped{' '}
              <a href="https://www.forbes.com/best-places-for-business/list/">Forbes'</a> list of the “Best Places for
              Business and Careers” the past few years in a row. Denver's economy is propelled by booming growth from
              various industries including manufacturing, technology, agriculture and the services sector (mainly
              tourism). Its geographical location means railroads are still big business, while the growing presence of
              high-tech companies pump up the local economy.
            </S.FactParagraph>
            <S.FactSubHeader htmlTag="h3" size="md">
              Economic Stats for Denver
            </S.FactSubHeader>
            <S.FactSubHeader htmlTag="h4" size="sm">
              Denver Employment Rates:
            </S.FactSubHeader>
            <S.FactParagraph size="sm" htmlTag="p">
              Denver's unemployment rate hovers around 3.0%, which is below the US average of 3.9%. The Denver job
              market increased 2.8% YoY. Future job growth over the next ten years is predicted to be 45.0%, which is
              higher than the US average of 33.5%. Average household income in Denver is $93,650 with a poverty rate of
              13.76%.
            </S.FactParagraph>
            <S.FactSubHeader htmlTag="h4" size="sm">
              Denver Tax Rates:
            </S.FactSubHeader>
            <S.FactParagraph size="sm" htmlTag="p">
              Denver sales tax is 7.7% (US average is 7.3%) Denver Income tax rate is 4.8% (US average is 4.6%) Property
              tax rate in Denver is 7.15% (subject to additional tax based on district)
            </S.FactParagraph>
          </>
        ),
      },
      {
        question: (
          <S.FactHeader htmlTag="h2" size="lg">
            How is the Traffic Congestion, Public Transportation and Walkability Around Denver?
          </S.FactHeader>
        ),
        answerType: 'answer',
        answer: (
          <>
            <S.FactSubHeader htmlTag="h3" size="md">
              Traffic Congestion in Denver:
            </S.FactSubHeader>
            <S.FactParagraph size="sm" htmlTag="p">
              Unfortunately, Denver, CO has some of the worst traffic congestion in the United States. The{' '}
              <a href="https://inrix.com/scorecard-city/?city=Denver%2C%20CO&index=89">INRIX traffic scorecard</a> for
              2019 rates Denver, CO the 21st most congested city in the Country. To reduce time wasted in traffic,
              Denver residents opt for biking to and from work or public transportation.
            </S.FactParagraph>
            <S.FactSubHeader htmlTag="h3" size="md">
              Biking or Cycling around Denver:
            </S.FactSubHeader>
            <S.FactParagraph size="sm" htmlTag="p">
              Transportation around town is an easy task by bicycle, as Denver ranks among the most bike-friendly cities
              in the U.S., with more than{' '}
              <a href="https://www.denvergov.org/content/denvergov/en/transportation-infrastructure/programs-services/bicycles/bike-maps.html">
                250 miles of designated bicycle lanes.
              </a>
            </S.FactParagraph>
            <S.FactSubHeader htmlTag="h3" size="md">
              Public Transportation for Denver:
            </S.FactSubHeader>
            <S.FactParagraph size="sm" htmlTag="p">
              <a href="https://www.rtd-denver.com/">RTD (Regional Transportation District)</a>, the public
              transportation system in Denver, is among the best in the country, linking the city of Denver to the
              surrounding areas by way of busses and light rail. Hundreds of daily busses service eight surrounding
              counties for a convenient and inexpensive alternative to driving.
            </S.FactParagraph>
            <S.FactSubHeader htmlTag="h3" size="md">
              Is Denver walkable?
            </S.FactSubHeader>
            <S.FactParagraph size="sm" htmlTag="p">
              Denver is overall a walking-friendly city. The closer to downtown the more walkable the city is but the
              further out the neighborhoods get, the less walkable they become.
            </S.FactParagraph>
          </>
        ),
      },
      {
        question: (
          <S.FactHeader htmlTag="h2" size="lg">
            What Activities to do in Denver?
          </S.FactHeader>
        ),
        answerType: 'answer',
        answer: (
          <>
            <S.FactParagraph size="sm" htmlTag="p">
              The proximity to the mountains means anything goes in terms of outdoor activities. Denver's museums and
              performing arts centers garner national recognition for their collections, as well as their unique
              designs. Small art galleries line the neighborhood of{' '}
              <a href="https://hotpads.com/lodo-denver-co/apartments-for-rent">LoDo (Lower Downtown)</a>, mixing
              perfectly with lively bars serving locally brewed beer. For music lovers, a show at Fiddler's Green or the
              legendary Red Rocks Amphitheater makes for an unforgettable night. The National Western Stock Show and
              Rodeo honors the city's cowboy heritage every January. After checking out the cowboys, don't forget to
              cheer on the Denver Broncos, the local NFL team. Denver is home to some of the most raucous sports fans in
              the country, all supporting the hometown teams: Broncos (NFL), Rockies (MLB), Nuggets (NBA) and Avalanche
              (NHL).
            </S.FactParagraph>
          </>
        ),
      },
      {
        question: (
          <S.FactHeader htmlTag="h2" size="lg">
            What are the Safest Neighborhoods in Denver, CO?
          </S.FactHeader>
        ),
        answerType: 'answer',
        answer: (
          <S.FactOrderedList>
            <li>
              <a href="https://hotpads.com/country-club-denver-co/apartments-for-rent">Country Club Neighborhood</a>
            </li>
            <li>
              <a href="https://hotpads.com/washington-park-denver-co/apartments-for-rent">
                Washington Park Neighborhood
              </a>
            </li>
            <li>
              <a href="https://hotpads.com/belcaro-denver-co/apartments-for-rent">Belcaro Neighborhood</a>
            </li>
            <li>
              <a href="https://hotpads.com/hilltop-denver-co/apartments-for-rent">Hilltop Neighborhood</a>
            </li>
            <li>
              <a href="https://hotpads.com/wellshire-denver-co/apartments-for-rent">Wellshire Neighborhood</a>
            </li>
            <li>
              <a href="https://hotpads.com/indian-creek-denver-co/apartments-for-rent">Indian Creek Neighborhood</a>
            </li>
            <li>
              <a href="https://hotpads.com/hampden-south-denver-co/apartments-for-rent">Hampden South Neighborhood</a>
            </li>
            <li>
              <a href="https://hotpads.com/southmoor-park-denver-co/apartments-for-rent">Southmoor Park Neighborhood</a>
            </li>
            <li>
              <a href="https://hotpads.com/marston-denver-co/apartments-for-rent">Marston Neighborhood</a>
            </li>
            <li>
              <a href="https://hotpads.com/fort-logan-denver-co/apartments-for-rent">Fort Logan Neighborhood</a>
            </li>
          </S.FactOrderedList>
        ),
      },
    ],
  },
};

export const DENVER_QUICK_ANSWER = quickAnswers['1543325321'];
export default quickAnswers;
